<div class="upload-file-container" *ngIf="projectType != ''">
  <!-- <div class="upload-file align-items-center" (click)="modalInstance.show()" [ngClass]="{'pe-none': isNdaSigned}">
    <img id="imageToChange" class="logo me-2 square" [src]="getImagePath + 'square.svg'" alt="Logo" *ngIf="!isNdaSigned"
      data-bs-toggle="modal" data-bs-target="#exampleModal" />
    <img id="imageToChange" class="logo me-2 square" [src]="getImagePath + 'checked_check_box.svg'" alt="Logo"
      *ngIf="isNdaSigned" /> -->
    <!-- <mat-checkbox
        id="ndaCheckbox"
        class="me-2"
        [(ngModel)]="isNdaSignedCheck()"
        [disabled]="isNdaSigned"
      ></mat-checkbox> -->

    <!-- <input type="checkbox" id="ndaCheckbox" class="me-2" data-bs-toggle="modal" data-bs-target="#exampleModal" >  -->
    <!-- <span class="">Check here to sign an NDA, or click Next to proceed</span>
    <div class="ms-auto d-flex align-items-center">
      <div class="">
        <img class="logo" [src]="getImagePath + 'insurance.svg'" alt="Logo" />
      </div>
    </div>
  </div> -->
  <div class="upload-file-note">
    <span class="note-style">Note:</span> Rapidise keeps your data
    <span class="secure-style"> 100% fully secure </span>and will not disclose,
    share, or reproduce your information in any way
  </div>

  <!-- Upload file card -->
  <div class="upload-file-card gap-0">
    <div class="font-semibold">Upload your Design to Start your Quote</div>
    <div class="file-desc text-small mt-1 d-flex mb-3">
      <span class="text-small" *ngIf="projectType == 1">Upload Gerber (Electronics)</span>
      <span *ngIf="projectType == 2" class="me-1"> Upload CAD (Mechanical)</span><span *ngIf="projectType == 3">Upload Gerber
        (Electronics) & Upload CAD (Mechanical)</span>
      Design Files in a ZIP Format
    </div>
    <div class="d-flex align-items-center gap-2 ">
      <label for="upload-gerber" *ngIf="projectType == 1 || projectType == 3">
        <div mat-button class="content-btn-photo">
          <div class="btn-first">
            <img class="logo" [src]="getImagePath + 'cloud_upload.svg'" alt="Gerber Logo" />
            <div class="upload-btn-text">Upload Gerber</div>
          </div>
        </div>
      </label>
      <input type="file" name="gerber" id="upload-gerber" #fileInputGerber class="display-n" accept=".zip"
        (change)="handleFileUpload($event, 'gerber')" />

      <label for="upload-cad" *ngIf="projectType == 2 || projectType == 3">
        <div mat-button class="content-btn-photo">
          <div class="btn-second">
            <img class="logo" [src]="getImagePath + 'cloud_upload.svg'" alt="CAD Logo" />
            <div class="upload-btn-text">Upload CAD</div>
          </div>
        </div>
      </label>
      <input type="file" name="cad" id="upload-cad" #fileInputCAD class="display-n" accept=".zip"
        (change)="handleFileUpload($event, 'cad')" />
    </div>
    
  </div>

  <div class="d-flex gap-3 flex-column width-upload-labels">
    <div class="d-flex align-items-center justify-content-center" *ngIf="projectType == 1 || projectType == 3">
      <div class="file-label me-3">Gerber File:</div>
      <div class="me-2 selected-file-name">
        <img class="logo" [src]="getImagePath + 'zip-logo.svg'" alt="Logo" />
      </div>
      <ng-container *ngIf="gerberFile != null && gerberFile.name   && gerberFile.name != 'null'; else noFileUploaded">
        <a class="selected-file-name">{{
          gerberFile.name && gerberFile.name != 'null'? gerberFile.name : gerberFile
          }}</a>
      </ng-container>
      <ng-container *ngIf="showGerberUploading; else uploadedStatusone">
        <div class="ms-auto d-flex align-items-center">
          <div class="d-flex align-items-center me-4">
            <div class="file-label">Uploading..</div>
            <mat-progress-bar mode="determinate" [value]="gerberProgress"></mat-progress-bar>
          </div>
          <div class="file-cancel" (click)="cancelFileUpload('gerber')">
            <img class="logo cursor-p" [src]="getImagePath + 'cancel.svg'" alt="Logo" />
          </div>
        </div>
      </ng-container>
      <ng-template #uploadedStatusone>
        <div class="ms-auto d-flex align-items-center" *ngIf="gerberProgress === 100 || gerberData">
          <div class="upload-status">Uploaded</div>
          <div class="file-cancel" (click)="cancelFileUpload('gerber')">
            <img class="logo cursor-p" [src]="getImagePath + 'cancel.svg'" alt="Logo" />
          </div>
        </div>
      </ng-template>
      <ng-template #noFileUploaded>
        <div class="no-file">No file uploaded</div>
      </ng-template>
    </div>
    <div class="d-flex align-items-center" *ngIf="projectType == 2 || projectType == 3">
      <div class="file-label me-3">CAD File:</div>
      <div class="me-2 selected-file-name">
        <img class="logo" [src]="getImagePath + 'zip-logo.svg'" alt="Logo" />
      </div>
      <ng-container *ngIf="cadFile; else noFileUploaded">
        <a [attr.href]="'#'" class="selected-file-name">{{ cadFile.name }}</a>
      </ng-container>
      <ng-container *ngIf="showCADUploading; else uploadedStatustwo">
        <div class="ms-auto d-flex align-items-center">
          <div class="d-flex align-items-center me-4">
            <div class="file-label">Uploading..</div>
            <mat-progress-bar mode="determinate" [value]="cadProgress"></mat-progress-bar>
          </div>
          <div class="file-cancel" (click)="cancelFileUpload('cad')">
            <img class="logo" [src]="getImagePath + 'cancel.svg'" alt="Logo" />
          </div>
        </div>
      </ng-container>
      <ng-template #uploadedStatustwo>
        <div class="ms-auto d-flex align-items-center" *ngIf="cadProgress === 100 || cadData">
          <div class="upload-status">Uploaded</div>
          <div class="file-cancel" (click)="cancelFileUpload('cad')">
            <img class="logo" [src]="getImagePath + 'cancel.svg'" alt="Logo" />
          </div>
        </div>
      </ng-template>
      <ng-template #noFileUploaded>
        <div class="no-file">No file uploaded</div>
      </ng-template>
    </div>
  </div>
  
  <div >
    <mat-divider class="mat-divider mb-4 mt-1"></mat-divider>
  <div class="upload">
    <div class="d-flex gap-3">
      <img class="logo" [src]="getImagePath + 'green_right_arrow.svg'" alt="Logo" />
      <div class="text-start w-100">
        <div class="fw-medium">Don't have a Design file?</div>
        <p class="font-13 d-flex e-quote-info-text">
          Manually input design information
          <a href="javascript:void(0)" class="link font-13 ms-1" (click)="onSkipStep()"> HERE</a>
        </p>
      </div>
    </div>
    <div class="ms-auto d-flex align-items-center">
      <div class="">
        <button class="btn btn-primary improved-add-btn" (click)="CheckUploadFiles()"
          [disabled]="!gerberFile || isNextButtonDisabled">
          Next
        </button>
      </div>
    </div>
  </div></div>

  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header model-nda-header">
          <h1 class="modal-title" id="exampleModalLabel">
            Sign an NDA
          </h1>
          <!-- <button type="button" class="btn-close btn-nda-close " data-bs-dismiss="modal" aria-label="Close"></button> -->
          <img class="logo btn-nda-close" [src]="getImagePath + 'closeNDAdialog.svg'" alt="Logo" data-bs-dismiss="modal"
            aria-label="Close" />
        </div>
        <div class="modal-body model-nda-body">
          <div class="font-14 fw-medium">
            Select a Manufacturing Facility from
          </div>
          <div class="nda-check">
            <mat-radio-group class="mat-option-group" aria-label="Select an option">
              <mat-radio-button class="mat-option-radio" value="1" checked>India</mat-radio-button>
              <mat-radio-button class="mat-option-radio" value="2">USA</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="fw-medium font-14 mt-5">Kindly fill below details</div>
          <form class="mt-2" id="signNdaForm" [formGroup]="signNdaForm">
            <div class="form-control-box bottom-spacing">
              <input type="text" class="form-control" id="name" placeholder="Name" formControlName="name"
                (input)="CheckIfInvalid()" />
              <div class="error-message" *ngIf="
                  signNdaForm.controls['name']?.dirty &&
                  signNdaForm.controls['name'].hasError('required')
                ">
                Name is required!
              </div>
              <div class="error-message" *ngIf="
                  signNdaForm.controls['name']?.dirty &&
                  signNdaForm.controls['name'].hasError('maxlength')
                ">
                Must not exceed 100 characters!
              </div>
              <div class="error-message"
              *ngIf="signNdaForm.controls['name']?.dirty && signNdaForm.controls['name'].hasError('pattern') && ! signNdaForm.controls['name'].hasError('maxlength')">
              Please enter valid name.
            </div>
            </div>
            <div class="form-control-box bottom-spacing">
              <input type="text" class="form-control" id="designation" placeholder="Designation"
                formControlName="designation" (input)="CheckIfInvalid()" />
              <div class="error-message" 
              *ngIf="signNdaForm.controls['designation']?.dirty && signNdaForm.controls['designation'].hasError('required')">
                Designation is required!
              </div>
              <div class="error-message" *ngIf="
                  signNdaForm.controls['designation']?.dirty &&
                  signNdaForm.controls['designation'].hasError('maxlength')
                ">
                Must not exceed 100 characters!
              </div>
              <div class="error-message"
              *ngIf="signNdaForm.controls['designation']?.dirty && signNdaForm.controls['designation'].hasError('pattern') && ! signNdaForm.controls['designation'].hasError('maxlength')">
              Please enter valid designation.
            </div>
            </div>
            <div class="form-control-box bottom-spacing">
              <input type="text" class="form-control" id="companyName" placeholder="Company Name"
                formControlName="companyName" (input)="CheckIfInvalid()" />
              <div class="error-message" *ngIf="
                  signNdaForm.controls['companyName']?.dirty &&
                  signNdaForm.controls['companyName'].hasError('required')
                ">
                Company Name is required!
              </div>
              <div class="error-message" *ngIf="
                  signNdaForm.controls['companyName']?.dirty &&
                  signNdaForm.controls['companyName'].hasError('maxlength')
                ">
                Must not exceed 100 characters!
              </div>
              <div class="error-message"
              *ngIf="signNdaForm.controls['companyName']?.dirty && signNdaForm.controls['companyName'].hasError('pattern') && ! signNdaForm.controls['companyName'].hasError('maxlength')">
              Please enter valid name.
            </div>
            </div>
            <div class="form-control-box bottom-spacing">
              <input type="text" class="form-control" id="companyRegistered" placeholder="Company Registered"
                formControlName="companyRegistered" (input)="CheckIfInvalid()" />
              <div class="error-message" *ngIf="
                  signNdaForm.controls['companyRegistered']?.dirty &&
                  signNdaForm.controls['companyRegistered'].hasError('required')
                ">
                Company Registered is required!
              </div>
              <div class="error-message" *ngIf="
                  signNdaForm.controls['companyRegistered']?.dirty &&
                  signNdaForm.controls['companyRegistered'].hasError('maxlength')
                ">
                Must not exceed 100 characters!
              </div>
              <div class="error-message"
              *ngIf="signNdaForm.controls['companyRegistered']?.dirty && signNdaForm.controls['companyRegistered'].hasError('pattern') && ! signNdaForm.controls['companyRegistered'].hasError('maxlength')">
              Invalid company register!
            </div>
            </div>
            <div class="form-control-box bottom-spacing">
              <input type="text" class="form-control" id="businessEmailAddress" placeholder="Business Email Address"
                formControlName="businessEmailAddress" (input)="CheckIfInvalid()" />
              <div class="error-message" *ngIf="
                  signNdaForm.controls['businessEmailAddress']?.dirty &&
                  signNdaForm.controls['businessEmailAddress'].hasError(
                    'required'
                  )
                ">
                Email Address is required!
              </div>
              <div class="error-message"
              *ngIf="signNdaForm.controls['businessEmailAddress']?.dirty && signNdaForm.controls['businessEmailAddress'].hasError('pattern')">
              Invalid email address!
            </div>
            </div>
            <div class="w-full d-flex mt-5">
              <button type="submit" class="nda-btn ms-auto" (click)="CloseModal()">
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>